const stages = ['Requirements','System architecture','Geometry','Materials','Boundary conditions','Physics','Mesh / discretization','Solver','Verification','Results','Engineering decision']
export function WorkflowDiagram() {
  return <div className="eng-workflow-diagram">{stages.map((stage,index) => <div key={stage}><span>{String(index+1).padStart(2,'0')}</span><strong>{stage}</strong>{index < stages.length-1 && <i>→</i>}</div>)}</div>
}
